<template>
  <div
    class="relative flex cursor-pointer gap-2 b rounded-xs bg-grey-90 px-2 py-4"
    :class="modelValue === type ? 'b-grey-10' : 'b-transparent'"
    @click="selectable && (modelValue = type)"
  >
    <vf-icon  :name="icon" size="md" />
    <span class="w-full f-col gap-1 text-sm">
      <base-radio
        v-if="selectable"
        v-model="modelValue"
        :aria-describedby="[type === 'pickup' ? pickupStoreId : '', descriptionId].join(' ')"
        class="o:static"
        :name="type"
        :value="type"
        @change="$emit('change', $event)"
      >
        <span class="fw-bold peer-focus-visible:outline-auto">
          {{ label }}
        </span>
      </base-radio>
      <span v-else class="fw-bold ">
        {{ label }}
      </span>
      <span v-if="type === 'standard'" :id="descriptionId" >
        <span class="f-col gap-1">
          <product-shipping-methods-estimated-delivery v-if="showEdd && variant?.buyable" :variant />
          <template v-else>
            <span>
              {{ $t.standardShipping }}
            </span>
            <span v-if="description">
              {{ description }}
            </span>
          </template>
        </span>
      </span>
      <template v-else-if="type === 'pickup'">
        <span v-if="selectedStore" :id="pickupStoreId" >
          {{ selectedStore.name }}
        </span>
        <base-button class="relative z-1 self-start py-px underlined" @click.stop="$emit('open-search')">
          {{ selectedStore ? $t.changeStore.title : $t.findStore }}
        </base-button>
        <span v-if="description" :id="descriptionId"  :class="{ 'c-red-30': error }">
          {{ description }}.
        </span>
      </template>
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { LocatorSearchItem } from '#types/brandify'
import type { IconName } from '#types/icon'
import type { SelectedVariant } from '#types/product'

declare global {
  interface Window {
    narvar: (targetElement: string, config: object) => void
  }
}

const { selectable = true, type = 'standard' } = defineProps<{
  description?: string
  error?: boolean
  icon?: IconName
  label: string
  selectable?: boolean
  selectedStore?: LocatorSearchItem
  showEdd?: boolean
  type?: 'standard' | 'pickup'
  variant?: SelectedVariant
}>()

defineEmits<{
  'change': [value: string]
  'open-search': []
}>()

const modelValue = defineModel<string>()
const id = useId()
const descriptionId = `shipping-method-${type}-description-${id}`
const pickupStoreId = `shipping-method-pickup-store-${id}`
</script>
